import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import NodeModalLlmMapper from '../../../components/react-flow/flow-builder-form/NodeModalLlmMapper';
import { LLM_MAPPER } from '../../../utils/NodeModalContants';
import LlmMapperAILoader from '../../../reusable-component/loader/LlmMapperAILoader';
import LlmMapperFlow from '../../../components/react-flow/LlmMapperFlow';
import { getLlmMapperData } from "../../../api's/ClusterAPI";

function AutoMapper({ selectedReadBlock, dataModelformField, setDataModelformField, attributes }) {
  const node = { key: LLM_MAPPER.nodeModalTitle, label: LLM_MAPPER.nodeModalTitle };
  const nodeId = `dndnode_${+new Date()}`;

  const { enqueueSnackbar } = useSnackbar();

  // const [sourceColumns, setSourceColumns] = useState([]);
  // const [targetColumns, setTargetColumns] = useState([]);
  const [llmLoader, setLlmLoader] = useState(false);

  const sourceSchema = dataModelformField?.source?.fetchedHeader;
  const targetSchema = attributes?.map((item) => {
    return {
      alias: '',
      header: item.name,
      checked: 'true',
      tableAlias: '',
      cast_datatype: item.data_type,
      default_value: '',
      attribute_type: 'static',
    };
  });

  const CommonProps = {
    open: true,
    handleClose: () => {},
    nodeId: `dndnode_${+new Date()}`,
    nodeName: node.key,
    nodes: {},
    edges: [],
    changeNodeName: () => {},
    setNodes: () => {},
    dataModel: true,
    dataModelformField,
    setDataModelformField,
    targetSchema,
  };

  const fetchLlmMapperDataByAI = async () => {
    setLlmLoader(true);
    try {
      const payload = {
        sourceColumns: sourceSchema.map((item) => ({ name: item.header, type: item.cast_datatype })),
        targetColumns: targetSchema.map((item) => ({ name: item.header, type: item.cast_datatype })),
      };

      const response = await getLlmMapperData(payload);
      if (response.status === 200) {
        const updatedData = [...response.data];
        const columnExists = (header) => {
          return updatedData.some((item) => item.destination_column.name === header);
        };
        targetSchema.forEach(({ header, cast_datatype }) => {
          if (!columnExists(header)) {
            updatedData.push({
              source_columns: [
                {
                  name: '',
                  type: '',
                },
              ],
              destination_column: {
                name: header,
                type: cast_datatype,
              },
            });
          }
        });

        // setFormField({
        //   ...formField,
        //   mappings: updatedData,
        // });
        setDataModelformField({
          ...dataModelformField,
          mappings: updatedData,
          llmMapper: {
            nodeId,
            nodeName: node.key,
            formField: {
              df: dataModelformField?.source?.formField?.alias,
              alias: `Auto_Mapper_${Date.now()}`,
            },
          },
        });
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Error while fetching data from LLM', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    } finally {
      setLlmLoader(false);
    }
  };

  return (
    <div>
      <strong>{node.label}</strong>
      {/* <NodeModalLlmMapper {...CommonProps} /> */}
      <div style={{ margin: '20px' }}>
        {llmLoader ? (
          <LlmMapperAILoader text={`${llmLoader ? 'Generating By AI' : ''}`} stars={llmLoader} />
        ) : (
          sourceSchema &&
          targetSchema && (
            <LlmMapperFlow
              fetchLlmMapperDataByAI={fetchLlmMapperDataByAI}
              setFormField={setDataModelformField}
              formField={dataModelformField}
              sourceColumns={sourceSchema}
              targetColumns={targetSchema}
              disableForm={false}
            />
          )
        )}
      </div>
    </div>
  );
}

export default AutoMapper;
